window.initializeSwiperWhenVisible = (selector, initialize) => {
  const slider = document.querySelector(selector);
  if (!slider || slider.dataset.swiperInitialized) return;

  const start = () => {
    if (slider.dataset.swiperInitialized) return;
    slider.dataset.swiperInitialized = 'true';
    initialize();
  };

  if (!('IntersectionObserver' in window)) {
    start();
    return;
  }

  const observer = new IntersectionObserver((entries) => {
    if (!entries[0].isIntersecting) return;
    start();
    observer.disconnect();
  }, { rootMargin: '350px 0px' });

  observer.observe(slider);
};
